//React
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

//Libs
import { Button, Dropdown, Icon } from "semantic-ui-react";
import swal from "sweetalert";

//Services
import { producaov2 as api } from "../../../../../services/apis";
import { systemLogs } from "../../../../../services/system_logs";
import { useRouter } from "../../../../../hooks/router";

//Components
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loader from "../../../../../components/Loader";
import Loading from "../../../../../components/Loading";

//Styles
import {
  Container,
  Title,
  Content,
  ContainerInputSearch,
  Input,
  SemanticTable,
  DropdownContainer,
} from "./styles";

const ListarCursos = () => {
  const [search, setSearch] = useState("");
  const [testes, setTestes] = useState([]);
  const [testesRespostas, setTestesRespostas] = useState([]);
  const [page, setPage] = useState(1);
  // const [isAtivos, setIsAtivos] = useState(true);
  const [loading, setLoading] = useState(false);

  const [idLicao, setIdLicao] = useState(null);

  // const [basePessoasOptions, setBasePessoasOptions] = useState([]);
  const [baseCursosOptions, setBaseCursosOptions] = useState([]);
  const [baseModulosOptions, setBaseModulosOptions] = useState([]);
  // const [baseLicoesOptions, setBaseLicoesOptions] = useState([]);

  const [pessoasOptions, setPessoasOptions] = useState([]);
  const [cursosOptions, setCursosOptions] = useState([]);
  const [modulosOptions, setModulosOptions] = useState([]);
  // const [licoesOptions, setLicoesOptions] = useState([]);

  const [pessoasFilter, setPessoasFilter] = useState(0);
  const [cursosFilter, setCursosFilter] = useState(0);
  const [modulosFilter, setModulosFilter] = useState(0);
  const [licoesFilter, setLicoesFilter] = useState(0);

  const router = useRouter();

  const cleanObject = (obj) => {
    const cleanedObject = obj || {};

    const formatedObj = Object.keys(cleanedObject)
      .filter((key) => cleanedObject[key])
      .reduce((sum, key) => {
        sum[key] = cleanedObject[key];
        return sum;
      }, {});

    return formatedObj;
  };

  const loadFilters = useCallback(async () => {
    try {
      const defaultOption = {
        key: 0,
        value: 0,
        text: "Todos",
      };

      const response = await api.get("admin/testes-resultado/filters");

      const { pessoas, cursos, modulos, licoes } = response.data;

      const formatedPessoasOptions = pessoas?.map((pessoa, index) => ({
        key: pessoa.id,
        value: pessoa.id,
        text: `[${pessoa.id}] - ${pessoa.nome}`,
      }));

      const formatedCursosOptions = cursos?.map((cursos, index) => ({
        key: cursos.id,
        value: cursos.id,
        text: `[${cursos.id}] - ${cursos.curso}`,
      }));

      const formatedModulosOptions = modulos?.map((modulo, index) => ({
        key: modulo.id,
        value: modulo.id,
        text: `[${modulo.id}] - ${modulo.titulo}`,
      }));

      // const formatedLicoesOptions = licoes?.map((licao, index) => ({
      //   key: licao.id,
      //   value: licao.id,
      //   text: `[${licao.id}] - ${licao.titulo}`,
      // }));

      const newPessoasOptions = [
        { ...defaultOption, text: "Pessoas" },
        ...formatedPessoasOptions,
      ];

      const newCursosOptions = [...formatedCursosOptions];

      const newModulosOptions = [
        { ...defaultOption, text: "Modulos" },
        ...formatedModulosOptions,
      ];

      // const newLicoesOptions = [
      //   { ...defaultOption, text: "Licoes" },
      //   ...formatedLicoesOptions,
      // ];

      setPessoasOptions(newPessoasOptions);
      setCursosOptions(newCursosOptions);
      setModulosOptions(newModulosOptions);
      // setLicoesOptions(newLicoesOptions);

      // setBasePessoasOptions(pessoas);
      setBaseCursosOptions(cursos);
      setBaseModulosOptions(modulos);
      // setBaseLicoesOptions(licoes);

      setCursosFilter(formatedCursosOptions[0].value);
    } catch (err) {
      swal("Não foi possível carregar os filtros", err, "error");
      setLoading(false);
    }
  }, [search]);

  const loadTestesRespostas = useCallback(
    async (
      page = 1,
      id_pessoa,
      id_curso,
      id_modulo
      // id_licao
    ) => {
      if (!id_curso) {
        swal("Selecione um curso", "erro", "error");
        return;
      }

      setLoading(true);

      try {
        const params = cleanObject({
          page,
          id_pessoa,
          id_curso,
          id_modulo,
          // id_licao,
        });

        const response = await api.get("admin/testes-resultados", { params });

        setTestesRespostas(response.data.items);
        await systemLogs("testes/resultados", "listou as respostas de testes");
        setLoading(false);
      } catch (err) {
        console.error(err);
        swal("Não foi possível carregar os testes", "erro", "error");
        setLoading(false);
      }
    },
    [search]
  );

  const relatoryTestesRespostas = useCallback(async () => {
    setLoading(true);

    if (!modulosFilter && !cursosFilter) {
      swal("Erro !", "Informe um filtro de CURSO ou MÓDULO", "error");
      return;
    }

    try {
      const params = cleanObject({
        id_pessoa: pessoasFilter,
        id_curso: cursosFilter,
        id_modulo: modulosFilter,
        // id_licao: licoesFilter,
      });

      const response = await api.get("admin/testes-resultados/relatorio", {
        params,
      });

      await systemLogs(
        "testes/resultados",
        "gerou relatório das respostas de testes"
      );
      setLoading(false);

      window.open(response.data.urlRelatorio);
    } catch (err) {
      console.error(err);
      swal("Não foi possível gerar relatório dos testes", "erro", "error");
      setLoading(false);
    }
  }, [pessoasFilter, cursosFilter, modulosFilter, licoesFilter]);

  useEffect(() => {
    const { id_licao } = router.query;

    setIdLicao(id_licao);
  }, [router]);

  useEffect(() => {
    loadFilters();
    // loadTestesRespostas();
  }, []);

  useEffect(() => {
    if (!cursosFilter) {
      setLoading(true);

      return;
    }

    setLoading(false);

    loadTestesRespostas(
      1,
      pessoasFilter,
      cursosFilter,
      modulosFilter
      // licoesFilter
    );
  }, [pessoasFilter, cursosFilter, modulosFilter]);

  useEffect(() => {
    console.log({ baseCursosOptions, baseModulosOptions });

    const newModulosOptions = baseModulosOptions
      ?.filter((modulo) => modulo.id_curso === cursosFilter)
      .map((modulo, index) => ({
        key: modulo.id,
        value: modulo.id,
        text: `[${modulo.id}] - ${modulo.titulo}`,
      }));

    setModulosOptions(newModulosOptions);
    setModulosFilter(newModulosOptions[0]?.value);

    // const newLicoesOptions = baseLicoesOptions
    //   ?.filter((licao) => licao.id_curso === cursosFilter)
    //   .map((licao, index) => ({
    //     key: licao.id,
    //     value: licao.id,
    //     text: `[${licao.id}] - ${licao.titulo}`,
    //   }));

    // setLicoesOptions(newLicoesOptions);
    // setLicoesFilter(newLicoesOptions[0]?.value);
  }, [cursosFilter]);

  // useEffect(() => {
  //   const newLicoesOptions = baseLicoesOptions
  //     ?.filter((licao) => licao.id_modulo === modulosFilter)
  //     .map((licao, index) => ({
  //       key: licao.id,
  //       value: licao.id,
  //       text: `[${licao.id}] - ${licao.titulo}`,
  //     }));

  //   setLicoesOptions(newLicoesOptions);
  //   setLicoesFilter(newLicoesOptions[0]?.value);
  // }, [modulosFilter]);

  const addPage = useCallback(async () => {
    const newPage = page + 1;

    setPage(newPage);
    await loadTestesRespostas(newPage);
  }, [page]);

  const removePage = useCallback(async () => {
    if (page <= 1) {
      return;
    }

    const newPage = page - 1;

    setPage(newPage);
    await loadTestesRespostas(newPage);
  }, [page]);

  const doSearch = useCallback(() => {
    loadTestesRespostas(page);
  }, [page, loadTestesRespostas]);

  const associateLicao = useCallback(
    async (index) => {
      try {
        const teste = testes[index];

        await api.put(`testes/${teste.id}/associate-licao/${idLicao}`);

        swal("Teste salvo !", "Teste atribuído com sucesso.", "success");
      } catch (err) {
        console.error(err);
        swal("Erro !", "Houve um problema a atribuir teste a lição", "error");
      }
    },
    [testes, idLicao]
  );

  return (
    <Container>
      <AdminMenu />
      <Content>
        <Title>Respostas do "Consolidando Conhecimento"</Title>

        <ContainerInputSearch>
          <DropdownContainer>
            <Dropdown
              placeholder={"Aluno"}
              fluid
              selection
              value={pessoasFilter}
              options={pessoasOptions}
              onChange={(e, { value }) => setPessoasFilter(value)}
              search
            />
          </DropdownContainer>

          <DropdownContainer>
            <Dropdown
              placeholder={"Curso"}
              fluid
              selection
              value={cursosFilter}
              options={cursosOptions}
              onChange={(e, { value }) => setCursosFilter(value)}
              search
            />
          </DropdownContainer>

          <DropdownContainer>
            <Dropdown
              placeholder={"Módulo"}
              fluid
              selection
              value={modulosFilter}
              options={modulosOptions}
              onChange={(e, { value }) => setModulosFilter(value)}
              search
            />
          </DropdownContainer>

          {/* <DropdownContainer>
            <Dropdown
              placeholder={"Lição"}
              fluid
              selection
              value={licoesFilter}
              options={licoesOptions}
              onChange={(e, { value }) => setLicoesFilter(value)}
              search
            />
          </DropdownContainer> */}
          <DropdownContainer>
            <Button onClick={relatoryTestesRespostas} fluid>
              Gerar Relatório
            </Button>
          </DropdownContainer>
        </ContainerInputSearch>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Pessoa</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Módulo</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Lição</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Teste</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Ações</SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body className="table-body">
            {loading ? (
              <Loading msg={"Buscando respostas de testes..."} />
            ) : (
              testesRespostas.map((testeResposta, index) => (
                <SemanticTable.Row>
                  <SemanticTable.Cell>{testeResposta.id}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    [{testeResposta?.pessoa?.id}] -{" "}
                    {testeResposta?.pessoa?.nome}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    [{testeResposta?.curso?.id}] - {testeResposta?.curso?.curso}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    [{testeResposta?.licao?.modulo?.id}] -{" "}
                    {testeResposta?.licao?.modulo?.titulo}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    [{testeResposta?.licao?.id}] -{" "}
                    {testeResposta?.licao?.titulo}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {testeResposta?.id_teste}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <>
                      <Button
                        title="Ir para página de edição de teste"
                        icon="edit icon"
                        size="small"
                        color={"grey"}
                        onClick={() =>
                          window.open(
                            `/admin/ead/testes/resultados/${testeResposta.id}`
                          )
                        }
                      />
                    </>
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))
            )}
          </SemanticTable.Body>
        </SemanticTable>
        {page > 1 && (
          <Button floated="left" onClick={removePage}>
            Voltar
          </Button>
        )}

        <Button floated="right" onClick={addPage}>
          Avançar
        </Button>
      </Content>
    </Container>
  );
};

export default ListarCursos;
